import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import StyledTextField from "../StyledTextField/StyledTextField";

export default function PrimaryAutocompleteSelect({
  label,
  options,
  value,
  onChange,
  nameKey,
  valueKey,
  defaultInput,
  title,
  width,
  multiple,
  disabled,
  error
}) {
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    if (defaultInput) {
      setSearchInput(defaultInput);
    }
  }, [defaultInput]);
  
  return (
    <Autocomplete
      id={`autocomplete-${label}`}
      freeSolo
      autoHighlight
      filterSelectedOptions
      multiple={multiple}
      disabled={disabled}
      value={value}
      onChange={(ev, newValue) => onChange(newValue)}
      options={options}
      sx={{
        width: width,
        "& .MuiOutlinedInput-root": {
          padding: "1.5px 39px 1.5px 0 !important",
        }
      }}
      inputValue={searchInput}
      PaperComponent={
        ({ children }) =>
          <Paper sx={{
            backgroundColor: "black_solid.10",
            fontSize: "body1.fontSize",
            fontWeight: "body1.fontWeight",
            boxShadow: "elevation1"
          }}
          >
            {children}
          </Paper>
      }
      onInputChange={(event, newInputValue) => {
        setSearchInput(newInputValue);
      }}
      isOptionEqualToValue={(option, value) => valueKey ? option[valueKey] === value[valueKey] : option === value}
      getOptionLabel={option =>
        option && valueKey ? `${option[valueKey]} - ${option[nameKey]}` : option
      }
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip key={`chip-${option}`} size="small" label={valueKey ? `${option[valueKey]} - ${option[nameKey]}` : option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) =>
        <StyledTextField
          {...params}
          label={label || title}
          error={error}
          size="small"
        />
      }
    />
  );
}

PrimaryAutocompleteSelect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  nameKey: PropTypes.string,
  valueKey: PropTypes.string,
  defaultInput: PropTypes.string,
  title: PropTypes.string,
  titleSize: PropTypes.string,
  width: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool
};